import _ from "lodash";

type MergeOptions = {
  allowEmptyArray?: boolean;
};

export const mergeObjectsWithFallback = <T>(
  primary: T,
  fallback: T,
  options: MergeOptions = {},
): T => {
  const { allowEmptyArray = false } = options;

  return _.mergeWith({}, fallback, primary, (objVal, srcVal) => {
    // If the value is an array, treat it atomically
    if (Array.isArray(srcVal)) {
      return allowEmptyArray ? srcVal : srcVal.length > 0 ? srcVal : objVal;
    }

    // Only override if srcVal is NOT null or undefined
    return srcVal !== null && srcVal !== undefined ? srcVal : objVal;
  });
};
